export interface Faq {
  q: string
  a: string[]
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Makeup Instructor Ready?',
    a: [
      'After completing your purchase, you receive digital access to the materials.',
      'No physical shipping is required.',
    ],
  },
  {
    q: 'Who is Makeup Instructor Ready for?',
    a: [
      'It is designed for makeup instructors, beauty educators, academy trainers and professional makeup artists who teach students.',
    ],
  },
  {
    q: 'Is this a makeup course for students?',
    a: [
      'No.',
      'The system is designed primarily for the educator.',
      'It helps you structure lessons, demonstrate techniques, organize practice, correct student mistakes and assess progress.',
    ],
  },
  {
    q: 'Is the material completely visual?',
    a: [
      'Yes.',
      'The system was intentionally designed around visual teaching.',
      'It includes diagrams, maps, step-by-step sequences, technique comparisons, placement references, practice tools and visual assessment resources.',
    ],
  },
  {
    q: 'Are the 150 classes ready to teach?',
    a: [
      'Yes.',
      'They are structured so you can select a class, review the objective and use the teaching sequence as your starting point.',
      'You can adapt the class to your students and available time.',
    ],
  },
  {
    q: 'Do I need to edit anything?',
    a: ['No.', 'The materials are delivered as finished PDFs.'],
  },
  {
    q: 'Can I edit the PDFs?',
    a: [
      'No.',
      'The resources are delivered in PDF format and are not editable files.',
    ],
  },
  {
    q: 'Are videos included?',
    a: [
      'No.',
      'Makeup Instructor Ready is a completely visual PDF teaching system.',
      'The material uses visual diagrams, technique sequences, maps, comparisons and teaching resources instead of video lessons.',
    ],
  },
  {
    q: 'Is this a makeup certification?',
    a: [
      'No.',
      'It is a professional teaching-resource system and does not replace any certification, qualification or licensing requirement that may apply in your location.',
    ],
  },
  {
    q: 'Can I use it internationally?',
    a: [
      'The material is designed for an international English-speaking audience.',
      'Professional, hygiene and regulatory requirements should always be followed according to your location.',
    ],
  },
  {
    q: 'Is it suitable for beginner students?',
    a: [
      'Yes.',
      'The system progresses from foundational concepts toward more advanced techniques and complete professional applications.',
    ],
  },
  {
    q: 'Is it suitable for advanced students?',
    a: [
      'Yes.',
      'Advanced sections include complete looks, client adaptation, bridal applications, troubleshooting, professional decision-making and higher-level assessments.',
    ],
  },
  {
    q: 'Are all 150 classes the same?',
    a: [
      'No.',
      'They cover different topics, skill levels, techniques, practice objectives and complete-look applications.',
    ],
  },
]
